import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import SidebarWrapper from '../../Layout/SidebarWrapper';
import { LayoutMainContainer } from '../../Layout/LayoutUI';
import WorkspaceNav from './WorkspaceNav';

const WorkspaceMainContainer = styled(LayoutMainContainer)`
  padding-top: 0;
  padding-right: 0;
  padding-left: 0;
`;

const WorkspaceLayout = () => (
  <>
    <SidebarWrapper id={'sidebar-container'}>
      <WorkspaceNav />
    </SidebarWrapper>
    <WorkspaceMainContainer>
      <Outlet />
    </WorkspaceMainContainer>
  </>
);

export default WorkspaceLayout;
